import { render, staticRenderFns } from "./joinCourse.vue?vue&type=template&id=14fd61ca&scoped=true"
import script from "./joinCourse.vue?vue&type=script&lang=ts"
export * from "./joinCourse.vue?vue&type=script&lang=ts"
import style0 from "./joinCourse.vue?vue&type=style&index=0&id=14fd61ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fd61ca",
  null
  
)

export default component.exports